var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMargin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "comp-lu0lfobr-bottom",
    preserveAspectRatio: "none",
    "data-bbox": "0 91 1920 209",
    viewBox: "0 91 1920 209",
    height: "100%",
    width: "100%",
    xmlns: "http://www.w3.org/2000/svg",
    "data-type": "shape",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "#comp-lu0lfobr-bottom > g { transform: scaleY(-1) translateY(-391px); } #comp-lu0lfobr-bottom { fill: #FFFFFF; }"))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M1920 291C1656.8 169.2 1323.3 91 960 91S262.5 169.2 0 291v9h1920v-9z M0,90 h1920 v210 h-1920 Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMargin);
export default __webpack_public_path__ + "static/media/margin.2e0cd8aed657a7a5090e4e538ccf2c87.svg";
export { ForwardRef as ReactComponent };